import 'normalize.css';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /* Reconfig css */
  body,
  html {
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    margin: 0;
    overflow: hidden;
    background-color: gray;
  }

  :root {
    /* Size */
    --sidebar-width: 76px;
    --header-height: 43px;
    --bottom-datatable-height: 350px;

    /* Mobile breakpoints */
    --mobile-sm: 480px;
    --mobile-md: 768px;
    --tablet: 1024px;

    /* Color */
    --color-secondary: #ec0071;
    --color-primary: #1677ff;
    --color-hoverBg: #0000000d;
    --text-color: #333333;
    --color-warning: #ffc107;
    --color-danger: #ef3a4c;
    --text-color-header: #26263c;
    --text-color-subheader: #959595;
    --color-border: #8a8a8a;
    --background-color-auth-form: #f0f0f080;
    --color-border-auth-form: #d0d7de;

    --shadows-100:
      0px 0px 1px rgba(24, 39, 75, 0.25), 0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
    --shadows-200:
      0px 0px 1px rgba(24, 39, 75, 0.24), 0px 4px 6px -4px rgba(24, 39, 75, 0.12), 0px 8px 8px -4px rgba(24, 39, 75, 0.08);
    --shadows-300:
      0px 0px 1px rgba(24, 39, 75, 0.23), 0px 6px 8px -6px rgba(24, 39, 75, 0.12),
      0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    --shadows-400:
      0px 0px 1px rgba(24, 39, 75, 0.22), 0px 6px 12px -6px rgba(24, 39, 75, 0.12),
      0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    --shadows-500:
      0px 0px 1px rgba(24, 39, 75, 0.21), 0px 6px 14px -6px rgba(24, 39, 75, 0.12),
      0px 10px 32px -4px rgba(24, 39, 75, 0.1);
    --shadows-600:
      0px 0px 1px rgba(24, 39, 75, 0.2), 0px 8px 18px -6px rgba(24, 39, 75, 0.12),
      0px 12px 42px -4px rgba(24, 39, 75, 0.12);
    --shadows-700:
      0px 0px 1px rgba(24, 39, 75, 0.19), 0px 8px 22px -6px rgba(24, 39, 75, 0.12),
      0px 14px 64px -4px rgba(24, 39, 75, 0.12);
    --shadows-800:
      0px 0px 1px rgba(24, 39, 75, 0.18), 0px 8px 28px -6px rgba(24, 39, 75, 0.12),
      0px 18px 88px -4px rgba(24, 39, 75, 0.14);
    --shadows-focus: 0 0 0 2px var(--colors-focus);
    --shadows-error: 0 0 0 2px var(--colors-errorFg);
    --shadows-active: 0 0 0 2px var(--colors-stroke);
    --shadows-paneShadow:
      0px 0px 1px rgba(24, 39, 75, 0.22), 0px 6px 12px -6px rgba(24, 39, 75, 0.12),
      0px 8px 24px -4px rgba(24, 39, 75, 0.08);
  }

  .show {
    display: block !important;
  }

  .none {
    display: none !important;
  }

  .error-message {
    color: var(--color-danger);
    min-height: 20px;
    font-size: 13px;
    margin: 4px 0;
    font-weight: 500;
  }

  a {
    text-decoration: none;
    color: var(--text-color);
  }

  p {
    margin-bottom: 0px;
  }

  li {
    list-style-type: none;
  }

  /* scroll bar */
  html *::-webkit-scrollbar {
    border-radius: 0;
    width: 8px;
  }
  html *::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: rgba(12, 13, 19, 0.3);
  }

  html *::-webkit-scrollbar-track {
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .mapboxgl-ctrl-attrib {
    display: none;
  }

  /* Mobile responsive styles */
  @media only screen and (max-width: 1024px) {
    #sidebar-wrapper {
      width: 0px;
    }
  }

  @media only screen and (max-width: 768px) {
    :root {
      --header-height: 48px;
      --bottom-datatable-height: 300px;
    }

    body {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 480px) {
    :root {
      --header-height: 44px;
      --bottom-datatable-height: 250px;
    }

    body {
      font-size: 13px;
    }

    /* Hide scrollbars on very small screens */
    html *::-webkit-scrollbar {
      width: 4px;
    }
  }

  i.fa-solid.fa-chevron-down {
    transition: all 150ms ease-out 0s;

    &.active {
      transform: rotate(180deg);
    }
  }

  .ant-tabs {
    height: 100%;

    @media (max-width: 768px) {
      .ant-tabs-tab {
        padding: 8px 12px !important;
        font-size: 14px !important;
      }
    }

    @media (max-width: 480px) {
      .ant-tabs-tab {
        padding: 10px 8px !important;
        font-size: 13px !important;
        min-width: 60px;
      }
    }
  }

  .ant-tabs-content-holder {
    display: flex;
  }

  .ant-tabs-tabpane {
    height: 100%;
  }

  /* Mobile improvements for Ant Design components */
  @media (max-width: 768px) {
    .ant-btn {
      padding: 6px 12px !important;
      font-size: 14px !important;
      min-height: 36px !important;
    }

    .ant-input {
      padding: 8px 12px !important;
      font-size: 14px !important;
      min-height: 36px !important;
    }

    .ant-table-thead > tr > th {
      padding: 8px !important;
      font-size: 13px !important;
    }

    .ant-table-tbody > tr > td {
      padding: 8px !important;
      font-size: 13px !important;
    }
  }

  @media (max-width: 480px) {
    .ant-btn {
      padding: 8px 12px !important;
      font-size: 15px !important;
      min-height: 44px !important;
    }

    .ant-input {
      padding: 10px 12px !important;
      font-size: 15px !important;
      min-height: 44px !important;
    }

    .ant-table {
      font-size: 12px !important;
    }

    .ant-table-thead > tr > th {
      padding: 6px 4px !important;
      font-size: 12px !important;
    }

    .ant-table-tbody > tr > td {
      padding: 6px 4px !important;
      font-size: 12px !important;
    }

    .ant-pagination {
      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        min-width: 40px !important;
        height: 40px !important;
        line-height: 38px !important;
      }
    }
  }

  .maplibregl-popup-tip {
    display: none;
  }
  .maplibregl-popup-close-button {
    padding: 8px;
    color: #ff000099;
  }

  @keyframes slideUp {
    from {
      transform: translateY(10%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideRight {
    0% {
      transform: translate(0);
      opacity: 0;
    }
    80% {
      transform: translateX(90px);
    }
    100% {
      transform: translateX(var(--sidebar-width));
      opacity: 1;
    }
  }
`;

function GlobalStyles({ children }: { children: any }) {
  return (
    <>
      <GlobalStyle />
      {children}
    </>
  );
}

export default GlobalStyles;
